// extracted by mini-css-extract-plugin
module.exports = {"downloadBtnPkmt":"download-btn-pkmt--downloadBtnPkmt--12CkKQZ"};